export default __webpack_public_path__ + "static/core-pic-mobile-9c10e522688e06e9c117ef3499d5439a.png";